const COOKIE_LIST = ["token", "ToctocCookie"];

export const getCookieListToctoc = (): string[] => COOKIE_LIST;
